import React, { useContext } from "react";
import Sheet from "@mui/joy/Sheet";
import Box from "@mui/joy/Box";
import Avatar from "@mui/joy/Avatar";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import { ChatContext } from "./mensajecontext";
import CircleIcon from "@mui/icons-material/Circle";

export default function TarjetachatAventura({
  titulo,
  foto,
  pais,
  ciudad,
  ultimomensaje,
  selectaventura,
  leido,
}) {
  const { ocultarDisenoChat } = useContext(ChatContext);
  let almacenamientoURL = process.env.REACT_APP_DOSPACES;

  return (
    <div>
      <Box
        sx={{ width: "100%" }}
        onClick={() => {
          selectaventura();
          ocultarDisenoChat();
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            p: 2,
            boxShadow: "sm",
            display: "flex",
            alignItems: "center",
            gap: 0,
            cursor: "pointer",
            borderRight: 0,
            borderLeft: 0,
            borderTop: 0,
            "&:hover": {
              backgroundColor: "neutral.softBg",
            },
          }}
        >
          <Box sx={{ display: "grid", gap: 2 }}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Avatar
                src={`${almacenamientoURL}/uploads/${foto}`}
                alt={`${titulo}`}
                sx={{ borderRadius: 8 }}
              />
              <Box sx={{ display: "grid", gap: 0.5 }}>
                <Typography level="title-sm">{titulo}</Typography>
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <Typography level="body-xs">
                    {ciudad}, {pais}
                  </Typography>
                </Box>
              </Box>
              {leido ? null : (
                <CircleIcon sx={{ fontSize: 8, color: "#FA812F" }} />
              )}
            </Box>
          </Box>
        </Sheet>
      </Box>
    </div>
  );
}
